export { default } from './BetaFeedbackBadge';
